import { ADD_AMP_ANALYTICS } from './constants';

const initialState = {
  ampAnalyticsEvents: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_AMP_ANALYTICS:
      return {
        ...state,
        ampAnalyticsEvents: {
          ...state.ampAnalyticsEvents,
          [action.ampAnalyticsEvent.selector]: action.ampAnalyticsEvent,
        },
      };
    default:
      return state;
  }
};
